"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MADDE_NOT_MAX_UZUNLUK = exports.formSemaTaslakSchema = exports.formSemaSchema = exports.formAlanSchema = exports.VARSAYILAN_CEVAP_SETI_KODU = exports.CEVAP_SETI_KUTUPHANESI = exports.ORTUK_BOLUM_KODU = exports.formBolumSchema = exports.MADDE_KANIT_AYARLARI = exports.cevapSetiSchema = exports.cevapSetiSecenegiSchema = exports.KAPSAM_DISI_SECENEK_ETIKETI = exports.KAPSAM_DISI_SECENEK_KODU = exports.CEVAP_ANLAMLARI = exports.formSecenekSchema = exports.DIGER_METNI_MAX_UZUNLUK = exports.DIGER_SECENEK_ETIKETI = exports.DIGER_SECENEK_KODU = exports.FORM_BESLEME_HEDEFLERI = exports.FORM_ALAN_KAYNAKLARI = exports.FORM_ALAN_TIPLERI = void 0;
exports.kutuphaneCevapSeti = kutuphaneCevapSeti;
exports.varsayilanCevapSeti = varsayilanCevapSeti;
exports.semaDuzenlemeIhlalleri = semaDuzenlemeIhlalleri;
exports.gorunurAlanlar = gorunurAlanlar;
exports.semaBolumleri = semaBolumleri;
exports.bolumluAlanlar = bolumluAlanlar;
exports.alanSecenekleri = alanSecenekleri;
exports.digerSeciliMi = digerSeciliMi;
exports.cevapSetiCoz = cevapSetiCoz;
exports.maddeKapsamDisiMi = maddeKapsamDisiMi;
exports.maddeKanitAyari = maddeKanitAyari;
exports.kontrolOzeti = kontrolOzeti;
exports.dogrulaFormCevaplari = dogrulaFormCevaplari;
/**
 * Form / şablon motorunun ŞEMA KURALLARI (F2·S4 — Kapsam §22.5, ERD §6c).
 *
 * Üç katmanın paylaştığı kural burada yaşar (paket sınırı §3): şablon
 * sürümünün `sema` jsonb'si nasıl kurulur, müşterinin neyi düzenleyebildiği,
 * ve dolu kaydın cevaplarının KENDİ SÜRÜMÜNE göre nasıl doğrulandığı.
 *
 * MOTORUN SINIRI (Kapsam §22.5/2 — bu dosyanın varlık gerekçesi kadar önemli):
 * motor ALAN ekler, KURAL YAZMAZ. Burada alanlar arası hesap, skorlama, eşik
 * ya da koşullu gösterim YOKTUR ve eklenmez — o mantık MODÜLÜN kararıdır
 * (risk matrisi kendi modülünde, seçenekli parametre olarak). Şemaya
 * "formül" / "kosul" / "hesap" anahtarı eklemek bu sınırı deler; ihtiyaç üç
 * farklı müşteriden ölçülürse (Yönerge §3.1) karar ürün sahibiyle açılır.
 */
const zod_1 = require("zod");
/**
 * Alan tipleri (Kapsam §22.5/4). Liste ÜRÜN kararıdır.
 *
 * ✏️ **TUR 3 (FORMLAR) — DOKUZUNCU TİP: `kontrol`** (Ş2). Bir *kontrol
 * maddesi* seçeneklerini tek tek TAŞIMAZ; bir **CEVAP SETİNDEN** okur
 * (şablonun varsayılanı ya da satırda seçilen set). Ayrı tip olmasının
 * gerekçesi seçim alanının XOR kuralıdır: `tekli_secim` seçenek kaynağını
 * *gömülü liste VEYA sözlük* olarak taşır ve üçüncü bir kaynak eklemek o
 * kuralı üç kollu yapardı. Ayrıca kontrol maddesinin cevabı bir ANLAM
 * taşır (olumlu · olumsuz · kapsam dışı) — seçim alanının kodu taşımaz.
 */
exports.FORM_ALAN_TIPLERI = [
    'metin',
    'uzun_metin',
    'sayi',
    'tarih',
    'tekli_secim',
    'coklu_secim',
    'evet_hayir',
    'dosya',
    'kontrol',
];
/** Seçim tipleri — seçenek kaynağı (gömülü liste XOR lookup) yalnız bunlarda. */
const SECIM_TIPLERI = ['tekli_secim', 'coklu_secim'];
/**
 * Alanın kaynağı: `urun` kütüphaneden gelir — SİLİNEMEZ, gizlenir; kimlik ve
 * tip özellikleri müşteriye kapalıdır (§19/9 nüsha kilidinin form kolu).
 * `musteri` alanında her şey serbest, silme dahil.
 */
exports.FORM_ALAN_KAYNAKLARI = ['urun', 'musteri'];
/**
 * Besleme işareti: alanın değeri BAŞKA bir sistemin kimlik eksenine girer
 * (PTW uygunluk kontrolü / İBYS bildirimi). Doluysa seçenek kaynağı LOOKUP
 * olmak ZORUNDADIR (Kapsam §22.5/4 kilitli kuralı) — gömülü metin listesi
 * eşleşmeyi sessizce bozar (tehlike_sinifi / sonraki_kontrol desenleriyle
 * aynı gerekçe: eşleşmesi gereken değer elle girdirilmez).
 * ÜRÜN alanının özelliğidir; müşteri koyamaz/kaldıramaz.
 */
exports.FORM_BESLEME_HEDEFLERI = ['ptw', 'ibys'];
/**
 * "DİĞER" SEÇENEĞİ — SABİT KALEM (28.09.2026; Kapsam §14 K-D1 · §19/13).
 *
 * §19/13'ün kilitli kuralı (*Diğer seçilince serbest metin zorunlu, raporda
 * ayrı sayılır*) form motorunda yalnız SÖZLÜK alanlarında karşılık buluyordu;
 * gömülü listeli seçim alanında (PTW tür şablonlarının tehlike · önlem ·
 * güvenlik ekipmanı listeleri) yoktu.
 *
 * ⚠️ **ŞABLON BAŞINA KURAL DEĞİL, ALAN TİPİNİN ÖZELLİĞİ** (§22.5/2 sınırı
 * aynen — motor alan ekler, kural yazmaz): alan `digerSecenegi: true` taşır;
 * seçeneği MOTOR ekler (`alanSecenekleri` — `cevapSetiCoz`un kapsam dışı
 * seçeneğiyle aynı desen) ve doğrulama her alanda aynı biçimde işler.
 *
 * ⚠️ **KOD AYRILMIŞTIR:** şablon kendi "diger" seçeneğini listeye YAZAMAZ
 * (`KAPSAM_DISI_SECENEK_KODU` deseni) — yazabilseydi metin zorunluluğu o
 * alanda sessizce koşmazdı ve aynı etiket iki farklı davranış taşırdı.
 */
exports.DIGER_SECENEK_KODU = 'diger';
exports.DIGER_SECENEK_ETIKETI = 'Diğer';
/** "Diğer" metninin üst sınırı: bir kalem adıdır, anlatı değil. */
exports.DIGER_METNI_MAX_UZUNLUK = 300;
/** Gömülü sabit liste seçeneği (şablona yazılır — sözlük nüshası değildir). */
exports.formSecenekSchema = zod_1.z.object({
    kod: zod_1.z
        .string()
        .trim()
        .regex(/^[a-z0-9][a-z0-9_]{0,60}$/, 'Seçenek kodu ASCII küçük harf/rakam/alt çizgi olmalı'),
    etiket: zod_1.z.string().trim().min(1).max(200),
});
// ── Ş1-Ş4 — BÖLÜM · CEVAP SETİ · KAPSAM DIŞI (Tur 3, Kapsam §22.5b) ─────────
/**
 * Bir kontrol maddesi cevabının ANLAMI. Motorun **kural yazmadığı** (§22.5/2)
 * sınırın içinde kalır: anlam bir hesap değil, cevabın NE OLDUĞUDUR — rapor
 * *"kaç madde uygunsuz"* diyebilsin diye. Puan/eşik/tetik YOKTUR (Ş5).
 */
exports.CEVAP_ANLAMLARI = ['olumlu', 'olumsuz', 'kapsam_disi'];
/**
 * KAPSAM DIŞI seçeneğinin SABİT kodu (Ş4). Set içeriğine elle yazılmaz —
 * `kapsamDisi` bayrağı açıkken motor ekler; sette aynı kodlu bir seçenek
 * bulunması REDDEDİLİR (aşağıdaki superRefine): iki kaynaktan gelen aynı kod
 * cevabın anlamını belirsiz bırakırdı.
 */
exports.KAPSAM_DISI_SECENEK_KODU = 'kapsam_disi';
exports.KAPSAM_DISI_SECENEK_ETIKETI = 'Kapsam dışı';
/** Cevap setinin bir seçeneği: kod + etiket + ANLAM. */
exports.cevapSetiSecenegiSchema = zod_1.z.object({
    kod: zod_1.z
        .string()
        .trim()
        .regex(/^[a-z0-9][a-z0-9_]{0,60}$/, 'Seçenek kodu ASCII küçük harf/rakam/alt çizgi olmalı'),
    etiket: zod_1.z.string().trim().min(1).max(60),
    anlam: zod_1.z.enum(['olumlu', 'olumsuz']),
});
/**
 * CEVAP SETİ (Ş2) — *madde bazında tek tek seçenek yazmak yerine SET.*
 *
 * ⚠️ **SET SÜRÜMÜN İÇİNDE YAŞAR ve böylece SÜRÜMLE DONDURULUR** (Ş2'nin son
 * cümlesi + §22.5/3). Kütüphane setleri `CEVAP_SETI_KUTUPHANESI`dedir ve
 * seçildikleri anda şablonun sürümüne **KOPYALANIR**; kopyalama hiçbir zaman
 * mevcut bir seti EZMEZ (INSERT-ONLY dağıtım kuralının form karşılığı) ve
 * kütüphanenin sonradan değişmesi yayınlanmış sürüme DOKUNMAZ.
 */
exports.cevapSetiSchema = zod_1.z
    .object({
    kod: zod_1.z
        .string()
        .trim()
        .regex(/^[a-z][a-z0-9_]{1,60}$/, 'Cevap seti kodu ASCII küçük harfle başlamalı'),
    ad: zod_1.z.string().trim().min(1).max(120),
    kaynak: zod_1.z.enum(exports.FORM_ALAN_KAYNAKLARI),
    secenekler: zod_1.z.array(exports.cevapSetiSecenegiSchema).min(2).max(10),
    /** Ş4 — İSTEĞE BAĞLI üçüncü seçenek; şablonu kuran açar/kapatır. */
    kapsamDisi: zod_1.z.boolean(),
})
    .superRefine((set, ctx) => {
    const kodlar = set.secenekler.map((s) => s.kod);
    if (new Set(kodlar).size !== kodlar.length) {
        ctx.addIssue({ code: 'custom', path: ['secenekler'], message: 'Seçenek kodu tekrar edemez' });
    }
    if (kodlar.includes(exports.KAPSAM_DISI_SECENEK_KODU)) {
        ctx.addIssue({
            code: 'custom',
            path: ['secenekler'],
            message: `'${exports.KAPSAM_DISI_SECENEK_KODU}' kodu ayrılmıştır — kapsam dışı seçeneği 'kapsamDisi' bayrağıyla açılır`,
        });
    }
    if (!set.secenekler.some((s) => s.anlam === 'olumsuz')) {
        ctx.addIssue({
            code: 'custom',
            path: ['secenekler'],
            message: 'Cevap seti en az bir OLUMSUZ seçenek taşımalı (uygunsuzluk okunamaz olurdu)',
        });
    }
});
/**
 * MADDE BAZINDA KANIT AYARI (Ş5/Ş8 — tur 3 artçısı, G1).
 *
 * Ş5 *"Not/fotoğraf zorunluluğu **MADDE bazında** ayarlanır"* der ve hemen
 * ardından sınırı çizer: ***cevaba bağlı zorunluluk yoktur.*** Bu yüzden ayar
 * üç HÂLLİDİR ama üç hâlin hiçbiri cevaba bakmaz — koşullu gösterimin
 * kardeşi olan *"olumsuz cevapta fotoğraf iste"* v1 DIŞIDIR ve bu enum onu
 * ifade EDEMEZ (edebilseydi motorun sınırı — §22.5/2 — delinirdi).
 *
 * TEK İSTİSNA Ş4'ün kendi muafiyetidir: **kapsam dışı** işaretli maddede
 * kanıt aranmaz (*"bu tesiste yok"* diyen maddeden fotoğraf istemek denetim
 * raporunu yalancı yapardı). Bu bir koşul değil, Ş4'ün *"tamamlanma
 * sayımında eksik görünmez"* cümlesinin kanıt tarafıdır.
 */
exports.MADDE_KANIT_AYARLARI = ['kapali', 'istege_bagli', 'zorunlu'];
/**
 * ŞABLON BÖLÜMÜ (Ş1) — **TEK DÜZEY, iç içe YOK.** `baslik` null ise ekranda
 * ve çıktıda başlık ÇİZİLMEZ: *bölüm kullanmayan şablon tek isimsiz bölümde
 * yaşar ve kullanıcı bölüm kavramını hiç görmez.*
 */
exports.formBolumSchema = zod_1.z.object({
    kod: zod_1.z
        .string()
        .trim()
        .regex(/^[a-z][a-z0-9_]{1,60}$/, 'Bölüm kodu ASCII küçük harfle başlamalı'),
    baslik: zod_1.z.string().trim().min(1).max(200).nullable(),
    sira: zod_1.z.number().int().min(0).max(10_000),
});
/** Bölümsüz (eski) şablonun ÖRTÜK tek bölümü — kullanıcıya hiç görünmez. */
exports.ORTUK_BOLUM_KODU = 'genel';
/**
 * KÜTÜPHANE CEVAP SETLERİ — **KİLİTLİ ÜRÜN VERİSİ** (NACE / form kütüphanesi
 * deseni). Dört set; ilki VARSAYILANDIR (Ş2/Ş3: *yeni şablon hiçbir seçim
 * yapılmadan ✓/✗ ile çalışır*).
 *
 * ⚠️ **BEŞİNCİ YOL MÜŞTERİNİNDİR (madde 121):** kurucu kendi setini yazar ve
 * o set `kaynak: 'musteri'` olarak şablonun sürümünde yaşar. **KONSOLİDASYON
 * ŞERHİ (Kapsam §22.5b):** serbest seçenekli maddeler holding
 * konsolidasyonunda **ortak eksen taşımaz**; ortak eksen isteyen SÖZLÜK
 * tabanlı alanı kullanır.
 */
exports.CEVAP_SETI_KUTUPHANESI = [
    {
        kod: 'olumlu_olumsuz',
        ad: 'Olumlu / olumsuz (√ ×)',
        kaynak: 'urun',
        kapsamDisi: false,
        // ⚠️ **İŞARETLER ÖLÇÜLEREK SEÇİLDİ, BEĞENİLEREK DEĞİL.** İlk yazımda
        // ✓ (U+2713) / ✗ (U+2717) vardı; PDF motorunun gömülü fontu (pdfmake
        // Roboto) bu kod noktalarını TAŞIMIYOR ve çıktı onları **sessizce
        // düşürüyordu** — ekranda işaret, kâğıtta BOŞ hücre. Ş6 *"işaret metne
        // çevrilmez"* der; çözüm işareti çıktıda çevirmek değil, **basılabilen
        // bir işaret seçmektir.** √ (U+221A) ve × (U+00D7) fontta VARDIR
        // (e2e PDF'i geri okuyup ikisini de arar) ve sahadaki elle atılan
        // tikin/çarpının aynısıdır.
        secenekler: [
            { kod: 'olumlu', etiket: '√', anlam: 'olumlu' },
            { kod: 'olumsuz', etiket: '×', anlam: 'olumsuz' },
        ],
    },
    {
        kod: 'evet_hayir',
        ad: 'Evet / Hayır',
        kaynak: 'urun',
        kapsamDisi: false,
        secenekler: [
            { kod: 'evet', etiket: 'Evet', anlam: 'olumlu' },
            { kod: 'hayir', etiket: 'Hayır', anlam: 'olumsuz' },
        ],
    },
    {
        kod: 'uygun_uygun_degil',
        ad: 'Uygun / Uygun değil',
        kaynak: 'urun',
        kapsamDisi: false,
        secenekler: [
            { kod: 'uygun', etiket: 'Uygun', anlam: 'olumlu' },
            { kod: 'uygun_degil', etiket: 'Uygun değil', anlam: 'olumsuz' },
        ],
    },
    {
        kod: 'var_yok',
        ad: 'Var / Yok',
        kaynak: 'urun',
        kapsamDisi: false,
        secenekler: [
            { kod: 'var', etiket: 'Var', anlam: 'olumlu' },
            { kod: 'yok', etiket: 'Yok', anlam: 'olumsuz' },
        ],
    },
];
/** Ş3 — mirasın en alt basamağı: hiçbir seçim yapılmamışsa bu set çalışır. */
exports.VARSAYILAN_CEVAP_SETI_KODU = 'olumlu_olumsuz';
function kutuphaneCevapSeti(kod) {
    return exports.CEVAP_SETI_KUTUPHANESI.find((s) => s.kod === kod) ?? null;
}
/** Varsayılan setin KOPYASI (çağıran üzerinde oynayabilsin diye). */
function varsayilanCevapSeti() {
    const set = kutuphaneCevapSeti(exports.VARSAYILAN_CEVAP_SETI_KODU);
    /* c8 ignore next */
    if (!set)
        throw new Error('Varsayılan cevap seti kütüphanede yok');
    return { ...set, secenekler: set.secenekler.map((s) => ({ ...s })) };
}
/**
 * Bir alan tanımı. `kod` alanın SABİT kimliğidir ve sürümler arası taşınır —
 * `form_answer.alan_kodu` buna bakar; kodu değiştirmek eski cevapları
 * öksüz bırakırdı (bu yüzden düzenlemede kod kilitlidir, aşağıda).
 */
exports.formAlanSchema = zod_1.z
    .object({
    kod: zod_1.z
        .string()
        .trim()
        .regex(/^[a-z][a-z0-9_]{1,60}$/, 'Alan kodu ASCII küçük harfle başlamalı (Türkçe karakter yok)'),
    etiket: zod_1.z.string().trim().min(1).max(300),
    yardim: zod_1.z.string().trim().min(1).max(500).nullable().optional(),
    tip: zod_1.z.enum(exports.FORM_ALAN_TIPLERI),
    zorunlu: zod_1.z.boolean(),
    gizli: zod_1.z.boolean(),
    sira: zod_1.z.number().int().min(0).max(10_000),
    kaynak: zod_1.z.enum(exports.FORM_ALAN_KAYNAKLARI),
    secenekler: zod_1.z.array(exports.formSecenekSchema).min(1).max(100).nullable().optional(),
    lookupListeKodu: zod_1.z.string().trim().min(1).max(60).nullable().optional(),
    besleme: zod_1.z.enum(exports.FORM_BESLEME_HEDEFLERI).nullable().optional(),
    /**
     * K-D1 — listenin sonuna motorun eklediği **Diğer** seçeneği. Yalnız
     * GÖMÜLÜ listeli seçim alanında (sözlükte "Diğer" sözlüğün kendi
     * kalemidir). Ürün alanında müşteriye KİLİTLİDİR (tip özelliği).
     */
    digerSecenegi: zod_1.z.boolean().nullable().optional(),
    /**
     * Ş1 — maddenin bölümü. **OPSİYONELDİR ve öyle kalır:** bölüm kavramından
     * önce yayınlanmış sürümler bu alanı taşımaz ve kendi şemalarıyla
     * okunmaya devam eder (§22.5/3). Boşsa madde ÖRTÜK bölümdedir.
     */
    bolumKodu: zod_1.z.string().trim().min(1).max(60).nullable().optional(),
    /**
     * Ş3 — maddenin cevap seti. Boşsa şablonun VARSAYILANI miras alınır;
     * dolu ise miras BOZULUR (satırda görünür). Yalnız `kontrol` tipinde.
     */
    cevapSetiKodu: zod_1.z.string().trim().min(1).max(60).nullable().optional(),
    /**
     * G1 — maddenin FOTOĞRAF ayarı. Boş/`kapali` ise doldurma yüzeyinde
     * fotoğraf alanı ÇİZİLMEZ ve uç o maddeye ek KABUL ETMEZ (görünmeyen
     * kapının arkası da kapalıdır — §2.40).
     */
    fotografAyari: zod_1.z.enum(exports.MADDE_KANIT_AYARLARI).nullable().optional(),
    /** G1 — maddenin NOT ayarı; fotoğrafın ikizi, taşıyıcısı `form_answer`. */
    notAyari: zod_1.z.enum(exports.MADDE_KANIT_AYARLARI).nullable().optional(),
    /**
     * SAHA TURU / S5 (05.09.2026 — Kapsam §27/S5): maddenin ATFI — serbest
     * metin (*"ISO 45001 §6.1.2"* · *"6331 md.15"* · *"PR-07"*). `yardim`ın
     * kardeşi: motor bunu YALNIZ TAŞIR — hesap, koşul, kural bağlamaz
     * (§22.5/2 sınırı). Ekranda madde yanında, PDF'te kolon, bulgu doğunca
     * uygunsuzluk açıklamasına TAŞINIR (gözlem satırı o anki kopyayı saklar).
     * ⚠️ Yükümlülük kütüphanesine BAĞ v2 — yanına anahtar gelir, yapı değişmez.
     */
    atif: zod_1.z.string().trim().min(1).max(200).nullable().optional(),
})
    .superRefine((alan, ctx) => {
    const gomulu = (alan.secenekler ?? null) !== null;
    const lookup = (alan.lookupListeKodu ?? null) !== null;
    if (SECIM_TIPLERI.includes(alan.tip)) {
        // XOR: seçim alanı TAM OLARAK bir kaynaktan beslenir.
        if (gomulu === lookup) {
            ctx.addIssue({
                code: 'custom',
                path: ['secenekler'],
                message: 'Seçim alanı ya gömülü liste ya lookup listesi taşır (tam olarak biri)',
            });
        }
        // Gömülü listede kod tekrarı sessiz veri kaybı olurdu.
        const kodlar = (alan.secenekler ?? []).map((s) => s.kod);
        if (new Set(kodlar).size !== kodlar.length) {
            ctx.addIssue({
                code: 'custom',
                path: ['secenekler'],
                message: 'Seçenek kodu tekrar edemez',
            });
        }
        // K-D1 — `diger` kodu AYRILMIŞTIR: seçenek bayrakla açılır, elle yazılmaz.
        if (kodlar.includes(exports.DIGER_SECENEK_KODU)) {
            ctx.addIssue({
                code: 'custom',
                path: ['secenekler'],
                message: `'${exports.DIGER_SECENEK_KODU}' kodu ayrılmıştır — Diğer seçeneği 'digerSecenegi' bayrağıyla açılır`,
            });
        }
        // K-D1 — sözlükten beslenen alanda "Diğer" sözlüğün kendi kalemidir.
        if (alan.digerSecenegi === true && lookup) {
            ctx.addIssue({
                code: 'custom',
                path: ['digerSecenegi'],
                message: 'Diğer seçeneği yalnız gömülü listeli seçim alanında açılır',
            });
        }
    }
    else if (gomulu || lookup) {
        ctx.addIssue({
            code: 'custom',
            path: ['tip'],
            message: 'Seçenek kaynağı yalnız tekli/çoklu seçim alanlarında olur',
        });
    }
    // K-D1 — başka tipte duran bayrak, doldurma yüzeyinin hiç okumayacağı ölü
    // bir ayardır (§2.40 — cevap seti kuralının kardeşi).
    if (alan.digerSecenegi === true && !SECIM_TIPLERI.includes(alan.tip)) {
        ctx.addIssue({
            code: 'custom',
            path: ['digerSecenegi'],
            message: 'Diğer seçeneği yalnız tekli/çoklu seçim alanlarında olur',
        });
    }
    // Ş3 — cevap seti YALNIZ kontrol maddesinde anlamlıdır: başka tipte
    // duran bir set, doldurma yüzeyinin hiç okumayacağı ölü bir ayardır
    // ("kaydettim, değişmedi" sınıfı — §2.40).
    if ((alan.cevapSetiKodu ?? null) !== null && alan.tip !== 'kontrol') {
        ctx.addIssue({
            code: 'custom',
            path: ['cevapSetiKodu'],
            message: 'Cevap seti yalnız kontrol maddesinde seçilir',
        });
    }
    // G1 — KANIT AYARI `dosya` ALANINDA OLMAZ. Gerekçe kaptadır, zevkte
    // değil: ekin taşıyıcısı `form_submission_attachment.alan_kodu`dur ve
    // bir `dosya` alanı zaten O KODLA ek taşır. İkisi açık olsaydı aynı kod
    // altında "alanın dosyası" ile "maddenin fotoğrafı" karışır, zorunluluk
    // sayımı hangisini saydığını bilemezdi.
    if (alan.tip === 'dosya') {
        for (const [ozellik, deger] of [
            ['fotografAyari', alan.fotografAyari ?? null],
            ['notAyari', alan.notAyari ?? null],
        ]) {
            if (deger !== null && deger !== 'kapali') {
                ctx.addIssue({
                    code: 'custom',
                    path: [ozellik],
                    message: 'Dosya alanı zaten ek taşır — ayrıca fotoğraf/not ayarı almaz',
                });
            }
        }
    }
    // KİLİTLİ KURAL (Kapsam §22.5/4): besleme varsa lookup ZORUNLU.
    if ((alan.besleme ?? null) !== null && !lookup) {
        ctx.addIssue({
            code: 'custom',
            path: ['lookupListeKodu'],
            message: 'PTW/İBYS besleyen alan sözlükten (lookup) beslenmek ZORUNDA — gömülü liste veya serbest metin kabul edilmez',
        });
    }
});
/** Şablon sürümünün BÖLÜM + CEVAP SETİ gövdesi — iki şema arasında paylaşılır. */
const SEMA_YAPISI = {
    /** Ş1 — bölümler. OPSİYONEL: bölümsüz (eski) şema aynen okunur. */
    bolumler: zod_1.z.array(exports.formBolumSchema).max(50).optional(),
    /** Ş2 — sürümde DONDURULMUŞ cevap setleri. */
    cevapSetleri: zod_1.z.array(exports.cevapSetiSchema).max(20).optional(),
    /** Ş3 — şablonun varsayılan seti; maddeler bunu miras alır. */
    varsayilanCevapSetiKodu: zod_1.z.string().trim().min(1).max(60).nullable().optional(),
};
/**
 * İKİ ŞEMANIN PAYLAŞTIĞI KURALLAR — tek yerde (biri gevşerse ikisi birden
 * gevşesin, biri unutulmasın).
 */
function semaYapiDenetimi(sema, ctx) {
    const kodlar = sema.alanlar.map((a) => a.kod);
    if (new Set(kodlar).size !== kodlar.length) {
        ctx.addIssue({ code: 'custom', path: ['alanlar'], message: 'Alan kodu tekrar edemez' });
    }
    const bolumKodlari = (sema.bolumler ?? []).map((b) => b.kod);
    if (new Set(bolumKodlari).size !== bolumKodlari.length) {
        ctx.addIssue({ code: 'custom', path: ['bolumler'], message: 'Bölüm kodu tekrar edemez' });
    }
    const bolumKumesi = new Set(bolumKodlari);
    for (const [i, alan] of sema.alanlar.entries()) {
        const bolumKodu = alan.bolumKodu ?? null;
        // Bölüm bildirilmemişse madde ÖRTÜK bölümdedir; bildirilmişse VAR OLMALI
        // — olmayan bölüme asılı madde ekranda ve çıktıda KAYBOLURDU.
        if (bolumKodu !== null && !bolumKumesi.has(bolumKodu)) {
            ctx.addIssue({
                code: 'custom',
                path: ['alanlar', i, 'bolumKodu'],
                message: `Bölüm bulunamadı: ${bolumKodu}`,
            });
        }
    }
    const setKodlari = (sema.cevapSetleri ?? []).map((s) => s.kod);
    if (new Set(setKodlari).size !== setKodlari.length) {
        ctx.addIssue({
            code: 'custom',
            path: ['cevapSetleri'],
            message: 'Cevap seti kodu tekrar edemez',
        });
    }
    // Bir set adı çözülebiliyorsa ya sürümün kendi listesinde ya KÜTÜPHANEDE
    // olmalı — çözülemeyen set, doldurma yüzeyinde SEÇENEKSİZ bir madde
    // üretirdi (görünen ama işlemeyen kontrol — §2.40).
    const cozulur = (kod) => setKodlari.includes(kod) || kutuphaneCevapSeti(kod) !== null;
    if (sema.varsayilanCevapSetiKodu && !cozulur(sema.varsayilanCevapSetiKodu)) {
        ctx.addIssue({
            code: 'custom',
            path: ['varsayilanCevapSetiKodu'],
            message: `Cevap seti bulunamadı: ${sema.varsayilanCevapSetiKodu}`,
        });
    }
    for (const [i, alan] of sema.alanlar.entries()) {
        if (alan.cevapSetiKodu && !cozulur(alan.cevapSetiKodu)) {
            ctx.addIssue({
                code: 'custom',
                path: ['alanlar', i, 'cevapSetiKodu'],
                message: `Cevap seti bulunamadı: ${alan.cevapSetiKodu}`,
            });
        }
    }
}
/**
 * Şablon sürümünün YAYIN şeması: alan dizisi BOŞ OLAMAZ.
 *
 * ⚠️ Bu şema **yayın ve doldurma** kapısıdır — `min(1)` kuralı BURADA yaşar
 * ve buradan alınmaz: boş şablon yayınlanamaz (Kapsam §22.5a — boş tuval).
 */
exports.formSemaSchema = zod_1.z
    .object({
    ...SEMA_YAPISI,
    alanlar: zod_1.z.array(exports.formAlanSchema).min(1).max(200),
})
    .superRefine(semaYapiDenetimi);
/**
 * TASLAK şeması — `formSemaSchema`nın BOŞ dizi kabul eden ikizi.
 *
 * **VARLIK SEBEBİ (işlevsel düzeltme turu):** boş tuvalin v1 taslağı
 * `{alanlar: []}` olarak doğar; bu değer `formSemaSchema`dan GEÇMEZ. Şablon
 * düzenleyicisi (ve düzenleme ucu) yayın şemasını okuduğu sürece **boş
 * taslak hiç parse edilemez, ekranda alan ekleme yüzeyi HİÇ çizilmez** ve
 * kullanıcı "boş şablon yayınlanamaz" uyarısıyla baş başa kalır: sistem
 * yapılamayacak bir şey ister.
 *
 * ⚠️ **KAPI GEVŞEMEDİ, İKİYE AYRILDI:** taslak boş olabilir, YAYIN olamaz.
 * Yayın kapısı `formSemaSchema`dır ve `publish` ucu onu okumaya devam eder —
 * bu şemayı yayın/doldurma yoluna taşıma.
 */
exports.formSemaTaslakSchema = zod_1.z
    .object({
    ...SEMA_YAPISI,
    alanlar: zod_1.z.array(exports.formAlanSchema).min(0).max(200),
})
    .superRefine(semaYapiDenetimi);
/**
 * Müşterinin ÜRÜN alanında düzenleyebildiği özellikler (Kapsam §22.5/1).
 * Bunun dışındaki her şey (kod, etiket, tip, seçenek kaynağı, besleme,
 * kaynak) üründen gelir ve düzenleme reddedilir — 422.
 *
 * ✏️ **TUR 3'TE İKİ ÜYE EKLENDİ: `bolumKodu` + `cevapSetiKodu`.** İkisi de
 * `sira`nın KARDEŞİDİR — kaydın ANLAMINI değil DÜZENİNİ belirlerler: madde
 * hangi başlığın altında duracak ve cevabı hangi sözcüklerle verilecek.
 * Kimlik (kod · etiket · tip · seçenek kaynağı · besleme) **kilitli kalır**;
 * Ş3 zaten *"madde satırında set değiştirilebilir"* der ve müşteri şablonun
 * VARSAYILAN setini de değiştirebildiği için, ürün maddesini bunun dışında
 * tutmak yalnızca **aynı şablonda iki farklı sözcük dağarcığı** üretirdi.
 */
const URUN_ALANINDA_SERBEST = [
    'zorunlu',
    'gizli',
    'sira',
    'bolumKodu',
    'cevapSetiKodu',
    // ✏️ **TUR 3 ARTÇISI — İKİ ÜYE DAHA: `fotografAyari` + `notAyari`.**
    // İkisi de `zorunlu`nun KARDEŞİDİR: maddenin ne SORDUĞUNU değil, cevabın
    // yanında ne KADAR KANIT istendiğini söylerler. Ürün maddesinde `zorunlu`
    // zaten serbestken kanıt ayarını kilitlemek, müşteriye *"soruyu zorunlu
    // yapabilirsin ama fotoğraf isteyemezsin"* demek olurdu.
    'fotografAyari',
    'notAyari',
    // ✏️ **SAHA TURU / S5 — `atif` DA SERBEST.** Atıf, müşterinin KENDİ
    // prosedürüne düştüğü çapraz referanstır (*"PR-07"*); ürün bunu bilemez.
    // Maddenin ANLAMINI değil BAĞLAMINI belirler — `bolumKodu`nun kardeşi.
    // Kimlik kilidi (kod · etiket · tip · seçenek kaynağı · besleme) aynen.
    'atif',
];
/**
 * ŞEMA DÜZENLEME KAPISI (Kapsam §22.5/1 — §19/9 nüsha kimlik kilidinin form
 * kolu). Yayınlanmış ÖNCEKİ sürümün şemasıyla yeni taslak karşılaştırılır:
 *
 * - ÜRÜN alanı SİLİNEMEZ (gizlenir — mevcut kayıtlar yaşamaya devam eder;
 *   silmek eski kayıtların etiketini kaybettirirdi).
 * - ÜRÜN alanında yalnız `zorunlu` / `gizli` / `sira` değişebilir.
 * - Müşteri kendi kaynağını `urun` diye işaretleyip kilitli alan uyduramaz.
 * - Var olan bir alanın KODU değiştirilemez (cevapları öksüz bırakırdı) —
 *   kod değişimi zaten "silme + ekleme" olarak görünür, ürün alanında ilk
 *   kural yakalar; müşteri alanında serbesttir (kendi kaydı, kendi kararı).
 *
 * Dönüş: ihlal listesi (boşsa düzenleme meşru). API 422'ye çevirir.
 */
function semaDuzenlemeIhlalleri(onceki, yeni) {
    const ihlaller = [];
    const yeniHarita = new Map(yeni.alanlar.map((a) => [a.kod, a]));
    const oncekiHarita = new Map(onceki.alanlar.map((a) => [a.kod, a]));
    for (const eski of onceki.alanlar) {
        if (eski.kaynak !== 'urun')
            continue;
        const guncel = yeniHarita.get(eski.kod);
        if (!guncel) {
            ihlaller.push({ tur: 'urun_alani_silinemez', alanKodu: eski.kod });
            continue;
        }
        // ✏️ 28.09.2026 (K-D1): anahtarların BİRLEŞİMİ taranır. Yalnız eski
        // sürümün anahtarları taranırken, eskide hiç yazılmamış kilitli bir
        // özellik (ör. `digerSecenegi`) yeni sürümde sessizce eklenebiliyordu.
        const ozellikler = new Set([...Object.keys(eski), ...Object.keys(guncel)]);
        for (const ozellik of ozellikler) {
            if (URUN_ALANINDA_SERBEST.includes(ozellik))
                continue;
            const deger = eski[ozellik];
            const yeniDeger = guncel[ozellik];
            if (JSON.stringify(deger ?? null) !== JSON.stringify(yeniDeger ?? null)) {
                ihlaller.push({ tur: 'urun_alani_kilitli_ozellik', alanKodu: eski.kod, ozellik });
            }
        }
    }
    // Yeni gelen `urun` kaynaklı alan = müşterinin kendine kilitli alan uydurması.
    for (const alan of yeni.alanlar) {
        if (alan.kaynak === 'urun' && !oncekiHarita.has(alan.kod)) {
            ihlaller.push({ tur: 'urun_alani_eklenemez', alanKodu: alan.kod });
        }
    }
    return ihlaller;
}
/** Kaydın gösterileceği/doldurulacağı alanlar: gizli olmayanlar, sıraya göre. */
function gorunurAlanlar(sema) {
    return sema.alanlar
        .filter((a) => !a.gizli)
        .sort((a, b) => a.sira - b.sira || a.kod.localeCompare(b.kod));
}
/**
 * Ş1 — bölüm listesi TÜRETİLİR: bildirilmemişse tek ÖRTÜK bölüm döner
 * (`baslik: null` → ekranda ve çıktıda başlık ÇİZİLMEZ).
 */
function semaBolumleri(sema) {
    const bildirilen = sema.bolumler ?? [];
    if (bildirilen.length === 0) {
        return [{ kod: exports.ORTUK_BOLUM_KODU, baslik: null, sira: 0 }];
    }
    return [...bildirilen].sort((a, b) => a.sira - b.sira || a.kod.localeCompare(b.kod));
}
/**
 * Bölümlere göre GÖRÜNÜR maddeler. Bölümü çözülemeyen madde (şema doğrulaması
 * bunu zaten reddeder — savunma) İLK bölüme düşer: madde kaybolmaz.
 */
function bolumluAlanlar(sema) {
    const bolumler = semaBolumleri(sema);
    const ilk = bolumler[0];
    const gorunur = [...sema.alanlar]
        .filter((a) => !a.gizli)
        .sort((a, b) => a.sira - b.sira || a.kod.localeCompare(b.kod));
    return bolumler.map((bolum) => ({
        bolum,
        alanlar: gorunur.filter((alan) => {
            const kod = alan.bolumKodu ?? null;
            if (kod === null)
                return bolum.kod === ilk.kod;
            return bolumler.some((b) => b.kod === kod) ? kod === bolum.kod : bolum.kod === ilk.kod;
        }),
    }));
}
/**
 * K-D1 — GÖMÜLÜ LİSTENİN ÇÖZÜLMÜŞ HÂLİ: şablonun seçenekleri + (bayrak açıksa)
 * motorun eklediği **Diğer**. ⚠️ **TEK OKUYUCU:** doldurma yüzeyi · kayıt
 * görünümü · PDF çıktısı · sunucu doğrulaması bunu çağırır; `alan.secenekler`i
 * doğrudan okuyan yer Diğer seçeneğini GÖREMEZ. Sözlükten beslenen alanda boş
 * döner (kalemler tenant sözlüğündedir).
 */
function alanSecenekleri(alan) {
    if (alan.lookupListeKodu)
        return [];
    const secenekler = (alan.secenekler ?? []).map((s) => ({ kod: s.kod, etiket: s.etiket }));
    if (alan.digerSecenegi === true) {
        secenekler.push({ kod: exports.DIGER_SECENEK_KODU, etiket: exports.DIGER_SECENEK_ETIKETI });
    }
    return secenekler;
}
/**
 * K-D1 — BU CEVAPTA "DİĞER" SEÇİLİ Mİ? **TEK YÜKLEM** (metin zorunluluğu ·
 * ekranda metin kutusunun görünürlüğü · elle girilen içerik sayımı aynı
 * cümleyi okur). Bayrağı kapalı alanda HER ZAMAN `false`.
 */
function digerSeciliMi(alan, deger) {
    if (alan.digerSecenegi !== true)
        return false;
    if (alan.tip === 'tekli_secim')
        return deger === exports.DIGER_SECENEK_KODU;
    if (alan.tip === 'coklu_secim') {
        return Array.isArray(deger) && deger.includes(exports.DIGER_SECENEK_KODU);
    }
    return false;
}
/**
 * Ş3 — MİRAS ZİNCİRİ, TEK YERDE: **madde → şablon varsayılanı → kütüphane
 * varsayılanı (✓/✗).** Zincirin son basamağı yüzünden *"yeni şablon hiçbir
 * seçim yapılmadan çalışır"* sözü tutar.
 *
 * Ş4 — `kapsamDisi` açıksa üçüncü seçenek MOTOR TARAFINDAN eklenir; set
 * içeriğine elle yazılmaz (kod ayrılmıştır).
 */
function cevapSetiCoz(sema, alan) {
    const kod = alan.cevapSetiKodu ?? sema.varsayilanCevapSetiKodu ?? exports.VARSAYILAN_CEVAP_SETI_KODU;
    const set = (sema.cevapSetleri ?? []).find((s) => s.kod === kod) ??
        kutuphaneCevapSeti(kod) ??
        varsayilanCevapSeti();
    const secenekler = set.secenekler.map((s) => ({
        kod: s.kod,
        etiket: s.etiket,
        anlam: s.anlam,
    }));
    if (set.kapsamDisi) {
        secenekler.push({
            kod: exports.KAPSAM_DISI_SECENEK_KODU,
            etiket: exports.KAPSAM_DISI_SECENEK_ETIKETI,
            anlam: 'kapsam_disi',
        });
    }
    return { kod: set.kod, ad: set.ad, secenekler };
}
/**
 * Ş4 — MADDE KAPSAM DIŞI MI? **TEK YÜKLEM.** Kanıt muafiyetini (G1) ve
 * `kontrolOzeti`nin *"beklenenden düşer"* satırını AYNI cümle besler; iki
 * ayrı yerde yazılsaydı biri kapsam dışı maddeyi eksik sayarken diğeri
 * saymaz olurdu.
 */
function maddeKapsamDisiMi(sema, alan, deger) {
    if (alan.tip !== 'kontrol' || typeof deger !== 'string')
        return false;
    return cevapSetiCoz(sema, alan).secenekler.find((s) => s.kod === deger)?.anlam === 'kapsam_disi';
}
/** G1 — ayarın çözülmüş hâli: bildirilmemiş ayar `kapali`dır. */
function maddeKanitAyari(alan, eksen) {
    const deger = eksen === 'fotograf' ? alan.fotografAyari : alan.notAyari;
    return deger ?? 'kapali';
}
function kontrolOzeti(sema, cevaplar) {
    const ozet = {
        toplam: 0,
        beklenen: 0,
        olumlu: 0,
        olumsuz: 0,
        kapsamDisi: 0,
        cevapsiz: 0,
        uygunsuzlar: [],
    };
    for (const alan of sema.alanlar) {
        if (alan.tip !== 'kontrol' || alan.gizli)
            continue;
        ozet.toplam += 1;
        const deger = cevaplar[alan.kod];
        const secenek = typeof deger === 'string'
            ? (cevapSetiCoz(sema, alan).secenekler.find((s) => s.kod === deger) ?? null)
            : null;
        if (maddeKapsamDisiMi(sema, alan, deger)) {
            ozet.kapsamDisi += 1;
            continue;
        }
        ozet.beklenen += 1;
        if (secenek?.anlam === 'olumlu')
            ozet.olumlu += 1;
        else if (secenek?.anlam === 'olumsuz') {
            ozet.olumsuz += 1;
            ozet.uygunsuzlar.push({
                alanKodu: alan.kod,
                etiket: alan.etiket,
                cevapEtiketi: secenek.etiket,
                atif: alan.atif ?? null,
            });
        }
        else
            ozet.cevapsiz += 1;
    }
    return ozet;
}
/** G1 — bir madde notunun üst sınırı: gözlem cümlesidir, rapor değil. */
exports.MADDE_NOT_MAX_UZUNLUK = 1000;
function alanDegerSchema(sema, alan) {
    switch (alan.tip) {
        case 'metin':
            return zod_1.z.string().trim().min(1).max(500);
        case 'uzun_metin':
            return zod_1.z.string().trim().min(1).max(5000);
        case 'sayi':
            return zod_1.z.number().finite();
        case 'tarih':
            return zod_1.z.iso.date();
        case 'evet_hayir':
            return zod_1.z.boolean();
        case 'tekli_secim':
            return alan.lookupListeKodu
                ? zod_1.z.uuid()
                : zod_1.z.enum(alanSecenekleri(alan).map((s) => s.kod));
        case 'coklu_secim':
            return zod_1.z
                .array(alan.lookupListeKodu
                ? zod_1.z.uuid()
                : zod_1.z.enum(alanSecenekleri(alan).map((s) => s.kod)))
                .min(1)
                .max(100);
        case 'kontrol':
            // Ş2/Ş3 — seçenek kümesi MİRAS ZİNCİRİNDEN gelir; kapsam dışı seçeneği
            // (Ş4) çözümleyici ekler. Sette olmayan kod REDDEDİLİR (fail-loud).
            return zod_1.z.enum(cevapSetiCoz(sema, alan).secenekler.map((sec) => sec.kod));
        case 'dosya':
            // Değer cevapta durmaz; ek satırları taşır (iki yerde tutmak senkron
            // sorunu üretirdi — §2.15/K4 türetme ilkesi).
            return zod_1.z.never();
    }
}
function dogrulaFormCevaplari(sema, cevaplar, options = {
    zorunluDenetimi: true,
}) {
    const hatalar = [];
    const degerler = [];
    const notlar = [];
    const digerMetinleri = [];
    const harita = new Map(sema.alanlar.map((a) => [a.kod, a]));
    const dosyali = new Set(options.dosyaliAlanlar ?? []);
    // ── G1 — NOTLAR: cevaplarla AYNI kapıdan geçer (ayrı bir doğrulama yolu
    //    açılmaz), ama ayrı bir listeye yazılır.
    for (const [kod, ham] of Object.entries(options.notlar ?? {})) {
        // ⚠️ **BOŞ NOT ÖNCE ELENİR:** boş metin *"not yazmadım"* demektir ve
        // hiçbir kural onun hakkında konuşmaz. Kapı önce koşsaydı, notu olmayan
        // bir maddeye boş anahtar gönderen istemci *"bu maddede not kapalı"*
        // hatası alırdı — kullanıcı hiçbir şey yazmamışken.
        const metin = (ham ?? '').trim();
        if (metin === '')
            continue; // boş not = not yok (satır yazılmaz)
        const alan = harita.get(kod);
        if (!alan) {
            hatalar.push({ alanKodu: kod, mesaj: 'Bu alan şablon sürümünde yok' });
            continue;
        }
        if (maddeKanitAyari(alan, 'not') === 'kapali') {
            hatalar.push({ alanKodu: kod, mesaj: 'Bu maddede not alanı kapalı' });
            continue;
        }
        if (alan.gizli) {
            hatalar.push({ alanKodu: kod, mesaj: 'Gizlenmiş alan not kabul etmez' });
            continue;
        }
        if (metin.length > exports.MADDE_NOT_MAX_UZUNLUK) {
            hatalar.push({
                alanKodu: kod,
                mesaj: `Not en çok ${exports.MADDE_NOT_MAX_UZUNLUK} karakter olabilir`,
            });
            continue;
        }
        notlar.push({ alanKodu: kod, notMetni: metin });
    }
    for (const kod of Object.keys(cevaplar)) {
        const alan = harita.get(kod);
        if (!alan) {
            hatalar.push({ alanKodu: kod, mesaj: 'Bu alan şablon sürümünde yok' });
            continue;
        }
        if (alan.gizli) {
            hatalar.push({ alanKodu: kod, mesaj: 'Gizlenmiş alan cevap kabul etmez' });
            continue;
        }
        if (alan.tip === 'dosya') {
            hatalar.push({ alanKodu: kod, mesaj: 'Dosya alanının değeri ek olarak yüklenir' });
            continue;
        }
        const deger = cevaplar[kod];
        if (deger === null || deger === undefined)
            continue; // boş bırakma = cevaplamama
        const sonuc = alanDegerSchema(sema, alan).safeParse(deger);
        if (!sonuc.success) {
            hatalar.push({ alanKodu: kod, mesaj: sonuc.error.issues[0]?.message ?? 'Değer geçersiz' });
            continue;
        }
        degerler.push({ alanKodu: kod, deger: sonuc.data });
    }
    // ── K-D1 — "DİĞER" METNİ (§19/13) ──────────────────────────────────────────
    // ⚠️ **ZORUNLULUK DENETİMİNDEN BAĞIMSIZDIR:** bu bir *"alan zorunlu mu"*
    // kuralı değil, bir DEĞER GEÇERLİLİĞİ kuralıdır — "Diğer" seçip ne olduğunu
    // yazmamak yarım bir cevaptır ve TASLAKTA da kabul edilmez (taslak serbestliği
    // boş bırakmayı kapsar, yarım bırakmayı değil).
    const temizDegerler = new Map(degerler.map((d) => [d.alanKodu, d.deger]));
    const hataliAlanlar = new Set(hatalar.map((h) => h.alanKodu));
    const digerGirdisi = new Map(Object.entries(options.digerMetinleri ?? {}).flatMap(([kod, ham]) => {
        const metin = (ham ?? '').trim();
        return metin === '' ? [] : [[kod, metin]];
    }));
    for (const [kod, metin] of digerGirdisi) {
        const alan = harita.get(kod);
        if (!alan) {
            hatalar.push({ alanKodu: kod, mesaj: 'Bu alan şablon sürümünde yok' });
            continue;
        }
        if (hataliAlanlar.has(kod))
            continue; // değeri zaten reddedildi
        if (!digerSeciliMi(alan, temizDegerler.get(kod))) {
            // Sessizce yutulursa kullanıcı yazdığının kaydedildiğini sanır (fail-loud).
            hatalar.push({
                alanKodu: kod,
                mesaj: `"${exports.DIGER_SECENEK_ETIKETI}" seçilmeden açıklama yazılamaz: ${alan.etiket}`,
            });
            continue;
        }
        if (metin.length > exports.DIGER_METNI_MAX_UZUNLUK) {
            hatalar.push({
                alanKodu: kod,
                mesaj: `"${exports.DIGER_SECENEK_ETIKETI}" açıklaması en çok ${exports.DIGER_METNI_MAX_UZUNLUK} karakter olabilir: ${alan.etiket}`,
            });
            continue;
        }
        digerMetinleri.push({ alanKodu: kod, digerMetni: metin });
    }
    for (const [kod, deger] of temizDegerler) {
        const alan = harita.get(kod);
        if (!alan || !digerSeciliMi(alan, deger) || digerGirdisi.has(kod))
            continue;
        hatalar.push({
            alanKodu: kod,
            mesaj: `"${exports.DIGER_SECENEK_ETIKETI}" seçildi — açıklaması yazılmalı: ${alan.etiket}`,
        });
    }
    if (options.zorunluDenetimi) {
        const dolu = new Set(degerler.map((d) => d.alanKodu));
        const notlu = new Set(notlar.map((n) => n.alanKodu));
        const degerHaritasi = new Map(degerler.map((d) => [d.alanKodu, d.deger]));
        for (const alan of sema.alanlar) {
            if (alan.gizli)
                continue;
            if (alan.zorunlu) {
                const karsilandi = alan.tip === 'dosya' ? dosyali.has(alan.kod) : dolu.has(alan.kod);
                if (!karsilandi) {
                    // ⚠️ Ş4 — KAPSAM DIŞI da bir cevaptır: `degerler`e girdiği için
                    // zorunluluk kapısını GEÇER; ayrı bir muafiyet dalı yazılmaz.
                    hatalar.push({
                        alanKodu: alan.kod,
                        mesaj: alan.tip === 'dosya'
                            ? `Zorunlu dosya alanı için en az bir ek yüklenmeli: ${alan.etiket}`
                            : `Zorunlu alan boş: ${alan.etiket}`,
                    });
                }
            }
            // ── G1 — ZORUNLU KANIT (fotoğraf/not) AYNI KAPIDA ────────────────────
            // ⚠️ **Ş4'ÜN MUAFİYETİ:** kapsam dışı işaretli maddede kanıt ARANMAZ.
            // Bu bir *"cevaba bağlı zorunluluk"* değildir (Ş5 onu reddeder): kapsam
            // dışı, maddenin **bu kayıtta hiç sorulmadığını** söyleyen tek
            // seçenektir ve zaten tamamlanma sayımından da düşer.
            if (maddeKapsamDisiMi(sema, alan, degerHaritasi.get(alan.kod)))
                continue;
            if (maddeKanitAyari(alan, 'fotograf') === 'zorunlu' && !dosyali.has(alan.kod)) {
                hatalar.push({
                    alanKodu: alan.kod,
                    mesaj: `Bu madde için fotoğraf zorunlu: ${alan.etiket}`,
                });
            }
            if (maddeKanitAyari(alan, 'not') === 'zorunlu' && !notlu.has(alan.kod)) {
                hatalar.push({ alanKodu: alan.kod, mesaj: `Bu madde için not zorunlu: ${alan.etiket}` });
            }
        }
    }
    return { gecerli: hatalar.length === 0, hatalar, degerler, notlar, digerMetinleri };
}
//# sourceMappingURL=form-schema.js.map